import { render, staticRenderFns } from "./produceInfo.pug?vue&type=template&id=1d9878b2&scoped=true&lang=pug&"
import script from "./produceInfo.ts?vue&type=script&lang=ts&"
export * from "./produceInfo.ts?vue&type=script&lang=ts&"
import style0 from "./produceInfo.styl?vue&type=style&index=0&id=1d9878b2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9878b2",
  null
  
)

export default component.exports